module.exports = __webpack_public_path__ + "img/icon_login_wechat@2x.a60a3fe1.png";